module.exports = __webpack_public_path__ + "static/skate-300f0838d7b0251c71d4cab054a7a652.png";